module.exports = __webpack_public_path__ + "img/jiaotong.52aeb6aa.png";